import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ReadonlyDataSource } from '../../../table-datasouces/readonly.datasource';
import { LogEntity } from '../../../dto/log-entity';
import { EmailLogService } from '../../../services/email-log.service';
import { DebtorDistribution } from '../../../dto/debtor-distribution';
import { DebtorDistributionService } from '../../services/debtor-distribution.service';
import { DebtorLogService } from '../../../services/debtor-log.service';

@Component({
  selector: 'app-debtors',
  templateUrl: './debtors.component.html',
  styleUrls: ['./debtors.component.scss']
})
export class DebtorsComponent  {
  debtorDistributionsColumns = [
    { columnDef: 'dateStart', header: 'Start distribution', 
      cell: (row: DebtorDistribution) =>  `${this.datePipe.transform(row.dateStart, 'dd.MM.yyyy HH:mm')}`},
    { columnDef: 'dateEnd', header: 'End distribution', 
      cell: (row: DebtorDistribution) =>  `${this.datePipe.transform(row.dateEnd, 'dd.MM.yyyy HH:mm')}`},
    { columnDef: 'errorsCount', header: 'Errors', cell: (row: DebtorDistribution) => `${row.errorsCount}`},
    { columnDef: 'successCount', header: 'Sent debtors', 
      cell: (row: DebtorDistribution) => `${row.successCount}` , class: 'center'},
  ];
  debtorDistributionsDataSource = new ReadonlyDataSource<DebtorDistribution>(this.debtorDistributionService);

  debtorsColumns = [
    { columnDef: 'date',    header: 'Date',    cell: (row: LogEntity) => `${this.datePipe.transform(row.date, 'dd.MM.yyyy HH:mm')}` },
    { columnDef: 'message', header: 'Message', cell: (row: LogEntity) => `${row.message}` },
    { columnDef: 'type',    header: 'Type',    cell: (row: LogEntity) => `${row.type == 0 ? 'Ok' : 'Error'}`, class: 'center' },
  ];
  debtorsDataSource = new ReadonlyDataSource<LogEntity>(this.debtorLogService);

  constructor(
    private datePipe: DatePipe,
    private debtorDistributionService: DebtorDistributionService,
    private debtorLogService: DebtorLogService,
  ) { }

  getViewLink = (item: DebtorDistribution): string => item.id.toString();
}
